<template>
    <section class="winners">
        <div class="container">
            <TheTitle id="winners" title="百大部落客得獎名單" :position="2" />
            <!-- <div class="winners__type">
                <div class="winners__type__container">
                    <div class="winners__type__tag" @click="choiceAwards = 'Gold'"
                        :class="{ 'active': choiceAwards === 'Gold' }">類別金獎</div>
                    <div class="winners__type__tag" @click="choiceAwards = 'Silver'"
                        :class="{ 'active': choiceAwards === 'Silver' }">類別銀獎</div>
                </div>
            </div> -->
            <AwardsList :type="choiceAwards" />
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';

import TheTitle from './widget/TheTitle.vue';
import AwardsList from './AwardsList.vue';

let choiceAwards = ref('Gold');


</script>

<style lang="scss" scoped>
@import '@/styles/theWinners';
</style>
